import {useEffect} from "react";
import {FloatingPortal} from "@floating-ui/react";
import {observer} from "mobx-react";
import AppSidebarMenuItems from "./app-sidebar-menu-items/app-sidebar-menu-items";
import appLayoutStore from "../../../../stores/app-layout-store";
import useSidebarSettings from "./use-sidebar-settings";
import dashboardSettingsStore from "../../../../stores/dashboard-settings-store";

const AppSidebar = observer(() => {
    const settings = useSidebarSettings(appLayoutStore.isSidebarOpen, (isOpen: boolean) => {
        appLayoutStore.isSidebarOpen = isOpen;
    });

    const { isMounted, status } = settings.transitionStatus;
    const { refs } = settings.floating;
    const { getFloatingProps } = settings.interactions;
    const menuItems = dashboardSettingsStore.menuItemsStore.parsedMenuItems;

    useEffect(() => {
        appLayoutStore.sidebarSettings = settings;
    }, [settings]);

    useEffect(() => {
        if (!appLayoutStore.showFloatingSidebar && status === 'open') {
            appLayoutStore.isSidebarOpen = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appLayoutStore.showFloatingSidebar, status]);

    if (appLayoutStore.showFloatingSidebar) {
        return (
            <FloatingPortal>
                {
                    isMounted && (
                        <div
                            className={`app-sidebar app-sidebar_floating ${status === 'open' ? 'app-sidebar_floating_open' : ''}`}
                            ref={refs.setFloating}
                            {...getFloatingProps()}
                            style={{
                                top: appLayoutStore.headerHeight,
                                // TODO (for Arthur): 12px is the margin of the sidebar.
                                //  Need to think if we can avoid this hardcode.
                                height: `calc(100vh - ${appLayoutStore.headerHeight}px - 12px)`
                            }}
                        >
                            <AppSidebarMenuItems items={menuItems} />
                        </div>
                    )
                }
            </FloatingPortal>
        )
    }

    return (
        <div className="app-sidebar">
            <AppSidebarMenuItems items={menuItems} />
        </div>
    )
});

export default AppSidebar;
